import Navbar from "../../components/navbar/navbar";
import Sidebar from "../../components/sidebar/sidebar";
import ObjectDatatable from "./objectdatatable";



const ObjectList = () => {
  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <ObjectDatatable></ObjectDatatable>
      </div>
    </div>
  );
};

export default ObjectList